export enum CompensationType {
  ToGoVoucherByEmail = 'togovoucherbyemail',
  BankAccount = 'bankaccount',
}
